export default __webpack_public_path__ + "static/media/djlogo.e779d9e9.png";